import { useEffect } from 'react';

import {
  addSocketEventListener,
  removeSocketEventListener,
} from 'application/store/slices/realtimeSlice/realtimeListener';

import { usePromoRollSynthJobsLazyQuery } from '@shared/api/graphql/generated';

const PAGE_SIZE = 20;

export const usePromoRollSynthFallback = (companyId: string) => {
  const [fetchJobs] = usePromoRollSynthJobsLazyQuery();

  const refetch = () => {
    fetchJobs({
      variables: {
        filters: { companyId },
        pagination: { page: 0, pageSize: PAGE_SIZE },
      },
      fetchPolicy: 'network-only',
    });
  };

  useEffect(() => {
    refetch();

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refetch();
      }
    };

    const onReconnect = () => {
      refetch();
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    addSocketEventListener('connect', onReconnect);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      removeSocketEventListener('connect', onReconnect);
    };
  }, [companyId]);
};
